// products/EditProduct/hooks/useFormHandlers.ts
import { useRef } from "react";

interface FormHandlersProps {
  formData: any;
  handleInputChange: (field: string, value: any) => void;
  removeEmojis: (val: string) => string;
  formatAmount: (val: string) => string;
}

export const useFormHandlers = ({ formData, handleInputChange, removeEmojis, formatAmount }: FormHandlersProps) => {
  // 🔹 Refs for Enter key navigation
  const productAmountRef = useRef<HTMLInputElement>(null);
  const selectCategoryRef = useRef<HTMLInputElement>(null);
  const selectStaffRef = useRef<HTMLInputElement>(null);

  // 🔹 Navigation handler
  const handleKeyPress = (e: React.KeyboardEvent, nextRef?: React.RefObject<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      nextRef?.current?.focus();
    }
  };

  // 🔹 Input Handlers
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => handleInputChange("productName", removeEmojis(e.target.value));

  const handleArabicNameChange = (e: React.ChangeEvent<HTMLInputElement>) => handleInputChange("arabicName", removeEmojis(e.target.value));

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (/^\d*\.?\d*$/.test(value)) {
      handleInputChange("amount", value);
    }
  };

  const handleAmountBlur = () => handleInputChange("amount", formatAmount(formData.amount));

  return {
    refs: { productAmountRef, selectCategoryRef, selectStaffRef },
    handleKeyPress,
    handleNameChange,
    handleArabicNameChange,
    handleAmountChange,
    handleAmountBlur,
  };
};
